<template>
  <div class="card">
    <div class="card-header" v-if="$slots.header || title">
      <slot name="header">
        <h4 class="card-title">{{title}}</h4>
      </slot>
    </div>
    <div class="card-body" v-if="$slots.default">
      <slot></slot>
    </div>
    <slot name="raw-content"></slot>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  name: "card",
  props: {
    title: String,
  }
};
</script>
<style>
</style>
